import { render, staticRenderFns } from "./PostContentLoader.vue?vue&type=template&id=78f25ad6&scoped=true"
import script from "./PostContentLoader.vue?vue&type=script&lang=js"
export * from "./PostContentLoader.vue?vue&type=script&lang=js"
import style0 from "./PostContentLoader.vue?vue&type=style&index=0&id=78f25ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f25ad6",
  null
  
)

export default component.exports